/* End poster-led promotion at midnight Eastern after October 27, including cached/open pages. */
(() => {
  let timer;
  function refreshAutumnCampaign() {
    clearTimeout(timer);
    const start = Date.parse('2026-10-28T00:00:00-04:00');
    const end = Date.parse('2026-11-25T17:00:00-05:00');
    if (Date.now() >= start && Date.now() < end && document.querySelector('[data-ff-sale-phase="autumn"]')) {
      const target = new URL(window.location.href);
      if (target.searchParams.get('ff_sale_refresh') !== 'pre-black-friday-2026') {
        target.searchParams.set('ff_sale_refresh', 'pre-black-friday-2026');
        window.location.replace(target.href);
        return;
      }
    }
    let nextCheck = 3600000;
    document.querySelectorAll('[data-ff-autumn-campaign]').forEach((element) => {
      const end = Date.parse(element.dataset.ffAutumnEnd);
      const remaining = end - Date.now();
      if (!Number.isFinite(end) || remaining <= 0) {
        element.hidden = true;
      } else {
        nextCheck = Math.min(nextCheck, remaining + 25);
      }
    });
    const endedHero = document.querySelector('[data-ff-autumn-hero][hidden]');
    const replacement = document.querySelector('template[data-ff-autumn-replacement]');
    if (endedHero && replacement) {
      endedHero.replaceWith(replacement.content.cloneNode(true));
      replacement.remove();
    }
    const campaignLogo = document.querySelector('[data-ff-autumn-logo]');
    const logoReplacement = document.querySelector('template[data-ff-autumn-logo-replacement]');
    if (campaignLogo && logoReplacement && !document.querySelector('[data-ff-autumn-hero]:not([hidden])')) {
      campaignLogo.replaceWith(logoReplacement.content.cloneNode(true));
      logoReplacement.remove();
    }
    document.querySelectorAll('[data-ff-autumn-fallback]').forEach((element) => {
      const active = element.parentElement.querySelector('[data-ff-autumn-campaign]:not([hidden])');
      element.hidden = Boolean(active);
    });
    const announcement = document.querySelector('.shopify-section--announcement-bar');
    if (announcement) {
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcement.clientHeight}px`);
    }
    if (document.querySelector('[data-ff-autumn-campaign]:not([hidden])')) {
      timer = setTimeout(refreshAutumnCampaign, Math.max(25, nextCheck));
    }
  }
  refreshAutumnCampaign();
  document.addEventListener('visibilitychange', refreshAutumnCampaign);
  window.addEventListener('pageshow', refreshAutumnCampaign);
  window.addEventListener('resize', refreshAutumnCampaign, { passive: true });
  document.addEventListener('shopify:section:load', refreshAutumnCampaign);
  document.addEventListener('click', (event) => {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target?.closest?.('a[href]');
    if (!link || !link.closest('.ff-bf-event')) return;
    const targetUrl = new URL(link.href, window.location.href);
    const currentUrl = new URL(window.location.href);
    if (targetUrl.origin !== currentUrl.origin || targetUrl.pathname !== currentUrl.pathname || targetUrl.search !== currentUrl.search || targetUrl.hash !== '#pre-black-friday-details') return;
    const target = document.getElementById('pre-black-friday-details');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
    target.focus({ preventScroll: true });
    if (currentUrl.hash !== targetUrl.hash) window.history.pushState(null, '', targetUrl.href);
  }, true);
})();
